<template>
   <div class="sidebar-page">
        <section class="sidebar-layout">
             
            
                <div >
                    <div class="block">
                       
                    <img
                        src="@/assets/trotairidea.png"
                        alt="The Trout!"
                        width="100%"
                    />
                    </div>
                    <b-menu class="is-custom-mobile">
                        <b-menu-list label="Film & c.">
                            <b-menu-item  tag="router-link" to="/vision" icon="theater" label="Film"></b-menu-item>
                            <b-menu-item  tag="router-link" to="/director" icon="account" label="Registi"></b-menu-item>
                            <b-menu-item  tag="router-link" to="/series" icon="television-classic" label="Serie"></b-menu-item>
                            <b-menu-item  tag="router-link" icon="gamepad" label="Videogame" to="/game"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list  label="Liste di valori" >
                                <b-menu-item tag="router-link" to="/language" icon="account-voice" label="Lingue"></b-menu-item>
                                <b-menu-item tag="router-link" to="/mode" icon="television" label="Modi"></b-menu-item>
                                <b-menu-item tag="router-link" to="/city" icon="city" label="Città" ></b-menu-item>
                                <b-menu-item  tag="router-link" label="Servizi" to="/service" icon="home"></b-menu-item>
                                <b-menu-item  tag="router-link" icon="account-multiple" label="Amici" to="/friend"></b-menu-item>
                                <b-menu-item  tag="router-link" icon="tag" label="Tag" to="/tag"></b-menu-item>
                                <b-menu-item  tag="router-link" icon="remote-tv" label="Stati serie" to="/series_status"></b-menu-item>
                                <b-menu-item  tag="router-link" icon="bulletin-board" label="Stati videogame" to="/game_status"></b-menu-item>
                                <b-menu-item  tag="router-link" icon="nintendo-switch" label="Piattaforme" to="/platform"></b-menu-item>
                                
                            </b-menu-list>
                
                        <b-menu-list label="Actions">
                            <b-menu-item tag="router-link"  icon="logout" label="Logout" to="/login" v-on:click.native="logout()" replace></b-menu-item>
                        </b-menu-list>
                    </b-menu>
                    <span class="is-size-7 is-italic"> Versione {{releaseVersion}} {{releaseDate}}/api {{serverRelease}}</span>
                </div>
          

            
        </section>
        
    </div>
</template>

<script>

const {version} = require("../../package.json")
const {date} = require("../config/builddate.json")

import api from "../api/api.js";

export default {
  name: 'sidebar',
  methods: {
      logout() {
          localStorage.removeItem('user');
      }
  },
  data() {
    return {
        releaseVersion: "",
        releaseDate: "",
        serverRelease: ""
        
    };
  },
  mounted() {
      this.releaseVersion = version;
      this.releaseDate = date;
      api.getVersion()
      .then((data)=>{
        this.serverRelease = data.data;
      })
  }
};
</script>

<style lang="scss">

.sidebar-page {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    .sidebar-layout {
        display: flex;
        flex-direction: row;
        min-height: 100%;
    }
}

</style>